import React from 'react';
import './DadosBasicos.css';

const DadosBasicos = ({ cliente, onEdit, onDelete }) => {
  if (!cliente) return null;

  // Get user role from localStorage
  const userRole = localStorage.getItem('userRole') || 'user';
  const userType = localStorage.getItem('userType') || '';
  const isMaster = userType === 'master';

  return (
    <div className="dados-basicos-container">
      <div className="dados-basicos-section">
        <h3>
          <i className="fas fa-building"></i>
          Informações Básicas
        </h3>
        <div className="dados-basicos-grid">
          <div className="dados-basicos-item">
            <span className="dados-basicos-label">Razão Social</span>
            <span className="dados-basicos-value">{cliente.razaoSocial}</span>
          </div>
          
          {cliente.nomeFantasia && (
            <div className="dados-basicos-item">
              <span className="dados-basicos-label">Nome Fantasia</span>
              <span className="dados-basicos-value">{cliente.nomeFantasia}</span>
            </div>
          )}
          
          <div className="dados-basicos-item">
            <span className="dados-basicos-label">CNPJ</span>
            <span className="dados-basicos-value">{cliente.cnpj}</span>
          </div>
          
          {cliente.cnes && (
            <div className="dados-basicos-item">
              <span className="dados-basicos-label">CNES</span>
              <span className="dados-basicos-value">{cliente.cnes}</span>
            </div>
          )}
        </div>
      </div>

      <div className="dados-basicos-section">
        <h3>
          <i className="fas fa-phone-alt"></i>
          Contato
        </h3>
        <div className="dados-basicos-grid">
          <div className="dados-basicos-item">
            <span className="dados-basicos-label">Email</span>
            <span className="dados-basicos-value">
              <i className="fas fa-envelope contact-icon"></i> {cliente.email}
            </span>
          </div>
          
          {cliente.telefone && (
            <div className="dados-basicos-item">
              <span className="dados-basicos-label">Telefone</span>
              <span className="dados-basicos-value">
                <i className="fas fa-phone contact-icon"></i> {cliente.telefone}
              </span>
            </div>
          )}
          
          {cliente.celularWhatsApp && (
            <div className="dados-basicos-item">
              <span className="dados-basicos-label">Celular/WhatsApp</span>
              <span className="dados-basicos-value">
                <i className="fab fa-whatsapp contact-icon whatsapp-icon"></i> {cliente.celularWhatsApp}
              </span>
            </div>
          )}
        </div>
      </div>

      <div className="dados-basicos-section">
        <h3>
          <i className="fas fa-map-marker-alt"></i>
          Endereço
        </h3>
        <div className="dados-basicos-grid">
          {cliente.endereco && (
            <div className="dados-basicos-item">
              <span className="dados-basicos-label">Logradouro</span>
              <span className="dados-basicos-value">
                {cliente.endereco}
                {cliente.numero && `, ${cliente.numero}`}
                {cliente.complemento && ` - ${cliente.complemento}`}
              </span>
            </div>
          )}
          
          {cliente.bairro && (
            <div className="dados-basicos-item">
              <span className="dados-basicos-label">Bairro</span>
              <span className="dados-basicos-value">{cliente.bairro}</span>
            </div>
          )}
          
          {cliente.cidade && (
            <div className="dados-basicos-item">
              <span className="dados-basicos-label">Cidade</span>
              <span className="dados-basicos-value">{cliente.cidade}</span>
            </div>
          )}
          
          {cliente.estado && (
            <div className="dados-basicos-item">
              <span className="dados-basicos-label">Estado</span>
              <span className="dados-basicos-value">{cliente.estado}</span>
            </div>
          )}
          
          {cliente.pais && (
            <div className="dados-basicos-item">
              <span className="dados-basicos-label">País</span>
              <span className="dados-basicos-value">{cliente.pais}</span>
            </div>
          )}
          
          {cliente.cep && (
            <div className="dados-basicos-item">
              <span className="dados-basicos-label">CEP</span>
              <span className="dados-basicos-value">{cliente.cep}</span>
            </div>
          )}
        </div>
      </div>

      {cliente.nomeCompletoResponsavel && (
        <div className="dados-basicos-section">
          <h3>
            <i className="fas fa-user-tie"></i>
            Responsável
          </h3>
          <div className="dados-basicos-grid">
            <div className="dados-basicos-item">
              <span className="dados-basicos-label">Nome Completo</span>
              <span className="dados-basicos-value">{cliente.nomeCompletoResponsavel}</span>
            </div>
            
            {cliente.cargo && (
              <div className="dados-basicos-item">
                <span className="dados-basicos-label">Cargo</span>
                <span className="dados-basicos-value">{cliente.cargo}</span>
              </div>
            )}
            
            {cliente.dataNascimento && (
              <div className="dados-basicos-item">
                <span className="dados-basicos-label">Data de Nascimento</span>
                <span className="dados-basicos-value">
                  {new Date(cliente.dataNascimento).toLocaleDateString('pt-BR')}
                </span>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Responsável por Assinar Capa de Requerimento */}
      {cliente.nomeCompletoResponsavel && (
        <div className="dados-basicos-section">
          <h3>
            <i className="fas fa-file-signature"></i>
            Responsável por Assinar Capa de Requerimento
          </h3>
          <div className="dados-basicos-grid">
            <div className="dados-basicos-item">
              <span className="dados-basicos-label">Nome Completo</span>
              <span className="dados-basicos-value">{cliente.nomeCompletoResponsavel}</span>
            </div>
            
            {cliente.cargo && (
              <div className="dados-basicos-item">
                <span className="dados-basicos-label">Cargo</span>
                <span className="dados-basicos-value">{cliente.cargo}</span>
              </div>
            )}
            
            {cliente.dataNascimento && (
              <div className="dados-basicos-item">
                <span className="dados-basicos-label">Data de Nascimento</span>
                <span className="dados-basicos-value">
                  {new Date(cliente.dataNascimento).toLocaleDateString('pt-BR')}
                </span>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Assinante DBE */}
      {cliente.nomeCompletoAssinanteDBE && (
        <div className="dados-basicos-section">
          <h3>
            <i className="fas fa-signature"></i>
            Assinante DBE
          </h3>
          <div className="dados-basicos-grid">
            <div className="dados-basicos-item">
              <span className="dados-basicos-label">Nome Completo</span>
              <span className="dados-basicos-value">{cliente.nomeCompletoAssinanteDBE}</span>
            </div>
            
            {cliente.cargoAssinanteDBE && (
              <div className="dados-basicos-item">
                <span className="dados-basicos-label">Cargo</span>
                <span className="dados-basicos-value">{cliente.cargoAssinanteDBE}</span>
              </div>
            )}
            
            {cliente.dataNascimentoAssinanteDBE && (
              <div className="dados-basicos-item">
                <span className="dados-basicos-label">Data de Nascimento</span>
                <span className="dados-basicos-value">
                  {new Date(cliente.dataNascimentoAssinanteDBE).toLocaleDateString('pt-BR')}
                </span>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default DadosBasicos;